import getConfig from 'next/config'
import { useContext, useEffect, useState } from 'react'

import { L_STORAGE_KEYS } from '@src/consts'
import { useFetchUserMe, useLoginTwoFactorAuthEmail } from '@src/hooks'
import { TfaTokenContext } from '@src/pages/_app.page'
import { getMailAddress, lStorage, toAuthenticationType } from '@src/utils'

import { UseSigninEmailMfa } from './type'
import { useMoveToNextUrl } from '../use-move-to-next-url'
import { STAGING_API_ENDPOINT } from '../use-signin/const'

export function useSigninEmailMfa({ setLoginErrors }: UseSigninEmailMfa) {
  const tfaTokenContext = useContext(TfaTokenContext)
  const { publicRuntimeConfig } = getConfig()
  const { API_ENDPOINT } = publicRuntimeConfig
  const isConnectedLocalToStg =
    API_ENDPOINT === STAGING_API_ENDPOINT &&
    process.env.NODE_ENV !== 'production'
  const [enabledFetchUserMe, setEnabledFetchUserMe] = useState(false)

  const loginEmailMfaMutation = useLoginTwoFactorAuthEmail()
  const fetchedUserMe = useFetchUserMe({ enabled: enabledFetchUserMe })
  const { moveToNextUrl } = useMoveToNextUrl()

  function handleSubmitEmailMfa(code: string) {
    loginEmailMfaMutation.mutate(
      {
        loginWithTwoFactorAuthEmailForm: {
          emailAddress: getMailAddress() ?? '',
          code,
          tfaToken: tfaTokenContext?.tfaToken ?? '',
        },
      },
      {
        onSuccess: ({ data }) => {
          if (isConnectedLocalToStg && data.token) {
            lStorage.setItem({ key: L_STORAGE_KEYS.TOKEN, value: data.token })
          }
          setEnabledFetchUserMe(true)
        },
        onError: (error) => {
          const errors = error.data?.errors
          if (errors?.code) {
            setLoginErrors(errors.code)
          } else if (errors?.tfaToken) {
            setLoginErrors(errors.tfaToken)
          } else {
            setLoginErrors(['不明なエラーが発生しました'])
          }
        },
      }
    )
  }

  useEffect(() => {
    if (fetchedUserMe.isSuccess) {
      const rawUserMe = fetchedUserMe.data.data
      const convertedResponse = toAuthenticationType(rawUserMe)
      lStorage.setItem({ key: L_STORAGE_KEYS.USER, value: convertedResponse })
      moveToNextUrl()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedUserMe.isSuccess])

  return {
    handleSubmitEmailMfa,
    isSubmittingEmailMfa: loginEmailMfaMutation.isPending,
  }
}
